import { Suspense, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar, Header, Loader } from "@workspace/shared";
import "../style.css";
import {
  // CommissionRules,
  Home,
  // Partners,
  // RunPayout,
  // Target,
  // PaymentLogs,
} from "@workspace/shared";
import { ROUTES } from "@/lib/routes";
import { removeAuthData, useUserDetails } from "@/redux/function";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import DiscountOutlinedIcon from "@mui/icons-material/DiscountOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import { PERMISSION, PermissionType } from "@/lib/permission";

const navItems = [
  {
    label: "Dashboard",
    path: "/",
    icon: Home,
    matchPaths: ["/"],
    permission: {
      module_name: PERMISSION.DEFAULT,
      permission: PermissionType.DEFAULT,
    },
  },
  {
    label: "Help & Support",
    path: ROUTES.TICKETS.BASE,
    icon: () => (
      <SupportAgentOutlinedIcon sx={{ color: "#696E7B", fontWeight: "400" }} />
    ),
    matchPaths: [ROUTES.TICKETS.BASE, ROUTES.SUPPORT_PHONE.BASE],
    permission: [
      {
        module_name: PERMISSION.DEFAULT,
        permission: PermissionType.DEFAULT,
      },
    ],
    children: [
      {
        label: "Tickets",
        path: ROUTES.TICKETS.BASE,
        matchPaths: [ROUTES.TICKETS.BASE],
        permission: {
          module_name: PERMISSION.DEFAULT,
          permission: PermissionType.DEFAULT,
        },
      },
      {
        label: "Support Contact Info",
        path: ROUTES.SUPPORT_PHONE.BASE,
        matchPaths: [ROUTES.SUPPORT_PHONE.BASE],
        permission: {
          module_name: "Default",
          permission: "Default",
        },
      },
    ],
  },
  {
    label: "Partner Program",
    path: ROUTES.COMMISSION_RULES.BASE,
    icon: () => (
      <ReceiptLongOutlinedIcon sx={{ color: "#696E7B", fontWeight: "400" }} />
    ),
    matchPaths: [
      ROUTES.COMMISSION_RULES.BASE,
      ROUTES.COMMISSION_RULES.CREATE,
      ROUTES.TARGET.BASE,
      ROUTES.TARGET.CREATE,
      ROUTES.PARTNER.BASE,
      ROUTES.PARTNER.CREATE,
      ROUTES.PARTNER.ID(":id").BASE,
      ROUTES.PARTNER.ID(":id").VIEW,
      ROUTES.RUN_PAYOUT.BASE,
      ROUTES.PAYOUT_LOG.BASE,
    ],
    permission: [
      {
        module_name: PERMISSION.COMMISSION_RULE,
        permission: PermissionType.VIEW,
      },
      { module_name: PERMISSION.TARGET, permission: PermissionType.VIEW },
      { module_name: PERMISSION.PARTNER, permission: PermissionType.VIEW },
      { module_name: PERMISSION.RUN_PAYOUT, permission: PermissionType.VIEW },
      { module_name: PERMISSION.PAYOUTS_LOG, permission: PermissionType.VIEW },
    ],
    children: [
      {
        label: "Commission Rules",
        path: ROUTES.COMMISSION_RULES.BASE,
        // icon: CommissionRules,
        matchPaths: [
          ROUTES.COMMISSION_RULES.BASE,
          ROUTES.COMMISSION_RULES.CREATE,
        ],
        permission: {
          module_name: PERMISSION.COMMISSION_RULE,
          permission: PermissionType.VIEW,
        },
      },
      {
        label: "Targets",
        path: ROUTES.TARGET.BASE,
        matchPaths: [ROUTES.TARGET.BASE, ROUTES.TARGET.CREATE],
        permission: {
          module_name: PERMISSION.TARGET,
          permission: PermissionType.VIEW,
        },
      },
      {
        label: "Partners",
        path: ROUTES.PARTNER.BASE,
        matchPaths: [
          ROUTES.PARTNER.BASE,
          ROUTES.PARTNER.CREATE,
          ROUTES.PARTNER.ID(":id").BASE,
          ROUTES.PARTNER.ID(":id").VIEW,
        ],
        permission: {
          module_name: PERMISSION.PARTNER,
          permission: PermissionType.VIEW,
        },
      },
      {
        label: "Run Payout",
        path: ROUTES.RUN_PAYOUT.BASE,
        matchPaths: [ROUTES.RUN_PAYOUT.BASE],
        permission: {
          module_name: PERMISSION.RUN_PAYOUT,
          permission: PermissionType.VIEW,
        },
      },
      {
        label: "Payouts Log",
        path: ROUTES.PAYOUT_LOG.BASE,
        matchPaths: [ROUTES.PAYOUT_LOG.BASE],
        permission: {
          module_name: PERMISSION.PAYOUTS_LOG,
          permission: PermissionType.VIEW,
        },
      },
    ],
  },
  {
    label: "Tenant",
    path: ROUTES.TENANT_SUBSCRIPTIONS.BASE,
    icon: () => (
      <ReceiptLongOutlinedIcon sx={{ color: "#696E7B", fontWeight: "400" }} />
    ),
    matchPaths: [
      ROUTES.TENANTS.BASE,
      ROUTES.TENANT_SUBSCRIPTIONS.BASE,
      ROUTES.TENANT_TRANSACTIONS.BASE,
      ROUTES.OFFLINE_REGISTRATION.BASE,
    ],
    permission: [
      { module_name: PERMISSION.TENANT, permission: PermissionType.VIEW },
      { module_name: PERMISSION.SUBSCRIPTION, permission: PermissionType.VIEW },
      { module_name: PERMISSION.TRANSACTION, permission: PermissionType.VIEW },
      {
        module_name: PERMISSION.OFFLINE_REGISTRATION,
        permission: PermissionType.VIEW,
      },
    ],
    children: [
      {
        label: "Tenants List",
        path: ROUTES.TENANTS.BASE,
        matchPaths: [ROUTES.TENANTS.BASE],
        permission: {
          module_name: PERMISSION.DEFAULT,
          permission: PermissionType.DEFAULT,
        },
      },
      {
        label: "Subscription",
        path: ROUTES.TENANT_SUBSCRIPTIONS.BASE,
        matchPaths: [ROUTES.TENANT_SUBSCRIPTIONS.BASE],
        permission: {
          module_name: PERMISSION.SUBSCRIPTION,
          permission: PermissionType.VIEW,
        },
      },
      {
        label: "Transaction",
        path: ROUTES.TENANT_TRANSACTIONS.BASE,
        matchPaths: [ROUTES.TENANT_TRANSACTIONS.BASE],
        permission: {
          module_name: PERMISSION.TRANSACTION,
          permission: PermissionType.VIEW,
        },
      },
      {
        label: "Offline Registration",
        path: ROUTES.OFFLINE_REGISTRATION.BASE,
        matchPaths: [ROUTES.OFFLINE_REGISTRATION.BASE],
        permission: {
          module_name: PERMISSION.OFFLINE_REGISTRATION,
          permission: PermissionType.VIEW,
        },
      },
      {
        label: "Impersonation Log",
        path: ROUTES.TENANT_IMPERSONATION_LOG.BASE,
        matchPaths: [ROUTES.TENANT_IMPERSONATION_LOG.BASE],
        permission: {
          module_name: PERMISSION.TENANT,
          permission: PermissionType.VIEW,
        },
      },
    ],
  },
  {
    label: "Model Wise Configuration",
    path: ROUTES.MODEL_WISE_CONFIGURATION.BASE,
    icon: () => (
      <ReceiptLongOutlinedIcon sx={{ color: "#696E7B", fontWeight: "400" }} />
    ),
    matchPaths: [
      ROUTES.MODEL_WISE_CONFIGURATION.BASE,
      ROUTES.MODEL_WISE_CONFIGURATION.CREATE,
    ],
    permission: {
      module_name: PERMISSION.MODEL_WISE_CONFIGURATION,
      permission: PermissionType.VIEW,
    },
  },
  {
    label: "Plan",
    path: ROUTES.PLAN.BASE,
    icon: () => (
      <ReceiptLongOutlinedIcon sx={{ color: "#696E7B", fontWeight: "400" }} />
    ),
    matchPaths: [ROUTES.PLAN.BASE, ROUTES.PLAN.CREATE],
    permission: {
      module_name: PERMISSION.DEFAULT,
      permission: PermissionType.DEFAULT,
    },
  },
  {
    label: "Coupons",
    icon: () => (
      <DiscountOutlinedIcon sx={{ color: "#6E737F", fontWeight: 400 }} />
    ),
    path: ROUTES.COUPON.BASE,
    matchPaths: [
      ROUTES.COUPON.BASE,
      ROUTES.COUPON.CREATE,
      `${ROUTES.COUPON.BASE}/:id`,
      ROUTES.COUPON_USAGES.BASE,
    ],
    permission: [
      { module_name: PERMISSION.COUPON, permission: PermissionType.VIEW },
      { module_name: PERMISSION.COUPON_USAGE, permission: PermissionType.VIEW },
    ],
    children: [
      {
        label: "Coupon",
        path: ROUTES.COUPON.BASE,
        matchPaths: [
          ROUTES.COUPON.BASE,
          ROUTES.COUPON.CREATE,
          ROUTES.COUPON.ID(":id").BASE,
        ],
        permission: {
          module_name: PERMISSION.COUPON,
          permission: PermissionType.VIEW,
        },
      },
      {
        label: "Coupon Usage",
        path: ROUTES.COUPON_USAGES.BASE,
        matchPaths: [ROUTES.COUPON_USAGES.BASE],
        permission: {
          module_name: PERMISSION.COUPON_USAGE,
          permission: PermissionType.VIEW,
        },
      },
    ],
  },
  {
    label: "Add-On Pricing",
    icon: () => (
      <ReceiptLongOutlinedIcon sx={{ color: "#6E737F", fontWeight: 400 }} />
    ),
    path: ROUTES.EMAIL_CREDITS_CONFIGURATION.BASE,
    matchPaths: [
      ROUTES.EMAIL_CREDITS_CONFIGURATION.BASE,
      ROUTES.STORAGE_PRICE_CONFIGURATION.BASE,
      ROUTES.GOOGLE_ADS_CONFIGURATION.BASE,
    ],
    permission: [
      {
        module_name: PERMISSION.EMAIL_CREDITS_CONFIGURATION,
        permission: PermissionType.VIEW,
      },

      {
        module_name: PERMISSION.STORAGE_PRICE_CONFIGURATION,
        permission: PermissionType.VIEW,
      },
      {
        module_name: PERMISSION.GOOGLE_ADS_CONFIGURATION,
        permission: PermissionType.VIEW,
      },
    ],
    children: [
      {
        label: "Email Config",
        path: ROUTES.EMAIL_CREDITS_CONFIGURATION.BASE,
        matchPaths: [ROUTES.EMAIL_CREDITS_CONFIGURATION.BASE],
        permission: {
          module_name: PERMISSION.EMAIL_CREDITS_CONFIGURATION,
          permission: PermissionType.VIEW,
        },
      },

      {
        label: "Storage Config",
        path: ROUTES.STORAGE_PRICE_CONFIGURATION.BASE,
        matchPaths: [ROUTES.STORAGE_PRICE_CONFIGURATION.BASE],
        permission: {
          module_name: PERMISSION.STORAGE_PRICE_CONFIGURATION,
          permission: PermissionType.VIEW,
        },
      },
      {
        label: "Google Ads Config",
        path: ROUTES.GOOGLE_ADS_CONFIGURATION.BASE,
        matchPaths: [ROUTES.GOOGLE_ADS_CONFIGURATION.BASE],
        permission: {
          module_name: PERMISSION.GOOGLE_ADS_CONFIGURATION,
          permission: PermissionType.VIEW,
        },
      },
    ],
  },
  {
    label: "Message Credit Configuration",
    path: ROUTES.MESSAGE_CREDIT_CONFIGURATION.BASE,
    icon: () => (
      <ReceiptLongOutlinedIcon sx={{ color: "#6E737F", fontWeight: 400 }} />
    ),
    matchPaths: [ROUTES.MESSAGE_CREDIT_CONFIGURATION.BASE],
    permission: {
      module_name: PERMISSION.MESSAGE_CREDIT_CONFIGURATION,
      permission: PermissionType.VIEW,
    },
  },
  {
    label: "User Management",
    icon: () => (
      <ReceiptLongOutlinedIcon sx={{ color: "#6E737F", fontWeight: 400 }} />
    ),
    path: ROUTES.USERS.BASE,
    matchPaths: [
      ROUTES.USERS.BASE,
      ROUTES.ROLESANDPERMISSIONS.BASE,
      ROUTES.ROLESANDPERMISSIONS.CREATE,
      `${ROUTES.ROLESANDPERMISSIONS.BASE}/:id`,
      ROUTES.USERS.CREATE,
      `${ROUTES.USERS.BASE}/:id`,
    ],
    permission: [
      { module_name: PERMISSION.USER, permission: PermissionType.VIEW },
      { module_name: PERMISSION.GROUP, permission: PermissionType.VIEW },
      { module_name: PERMISSION.ACTIVITY_LOG, permission: PermissionType.VIEW },
    ],
    children: [
      {
        label: "Roles and Permission",
        path: ROUTES.ROLESANDPERMISSIONS.BASE,
        matchPaths: [ROUTES.ROLESANDPERMISSIONS.BASE],
        permission: {
          module_name: PERMISSION.GROUP,
          permission: PermissionType.VIEW,
        },
      },
      {
        label: "Users",
        path: ROUTES.USERS.BASE,
        matchPaths: [
          ROUTES.USERS.BASE,
          ROUTES.USERS.CREATE,
          `${ROUTES.USERS.BASE}/:id`,
        ],
        permission: {
          module_name: PERMISSION.USER,
          permission: PermissionType.VIEW,
        },
      },
      {
        label: "Users Activities",
        path: ROUTES.USERS_ACTIVITIES.BASE,
        matchPaths: [ROUTES.USERS_ACTIVITIES.BASE],
        permission: {
          module_name: PERMISSION.ACTIVITY_LOG,
          permission: PermissionType.VIEW,
        },
      },
    ],
  },
];

const MOBILE_BREAKPOINT = 900;

const AppLayout = () => {
  const userDetails = useUserDetails();

  const [mobileOpen, setMobileOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < MOBILE_BREAKPOINT,
  );

  const toggleMobileDrawer = () => setMobileOpen((v) => !v);
  const toggleSidebar = () => setSidebarOpen((v) => !v);

  useEffect(() => {
    const setVhVar = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--app-vh", `${vh}px`);
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
      setVhVar();
    };

    setVhVar();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="h-screen w-screen overflow-hidden flex flex-col">
      <div className="flex overflow-hidden flex-1 min-h-0 relative">
        <Sidebar
          mobileOpen={mobileOpen}
          handleDrawerToggle={toggleMobileDrawer}
          sidebarOpen={sidebarOpen}
          isMobile={isMobile}
          bannerOffset={0}
          navItems={navItems}
          removeAuthData={removeAuthData}
          user={userDetails}
        />

        <div className="flex flex-col flex-1 overflow-hidden transition-[margin-left] duration-200 ease-in-out">
          <div className="h-16 shrink-0 bg-sidebar">
            <Header
              onDrawerToggle={toggleMobileDrawer}
              onDrawerCollapse={toggleSidebar}
              sidebarOpen={sidebarOpen}
              user={userDetails}
              navigateRoutes={{
                PROFILE: ROUTES.PROFILE.BASE,
                SETTING: ROUTES.SETTINGS.BASE,
              }}
              myAccount="My Account"
            />
          </div>

          <main className="flex-1 m-2 pt-0 px-(--spacing-3) pb-(--spacing-3) overflow-hidden">
            <div className="relative h-full bg-neutral-50 dark:bg-[#2e2e2e] border border-neutral-200 rounded-[1.25rem] overflow-hidden flex flex-col">
              <div className="flex-1 p-5 overflow-auto custom-scrollbar">
                <Suspense fallback={<Loader type="content" />}>
                  <Outlet />
                </Suspense>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default AppLayout;
